/*
 * @Author: Dzy
 * @Date: 2022-08-08 18:37:00
 * @LastEditors: Dzy
 * @LastEditTime: 2022-11-07 15:23:51
 * @Description: 获取验证码，认证中心：登录、登出
 */
import { SHA256 } from 'crypto-js'
import request, { requestBlob, requestByThirdPath } from '@/utils/request'
import dayjs from 'dayjs'
import { API_SSO, API_BASE } from '@Con'

// 获取验证码
export const getCaptcha = async () => {
  const randomStr = dayjs().valueOf() + Math.random().toString(36).slice(2)
  try {
    const response = await requestBlob('/api/code', { randomStr })

    let imgUrl = window.URL.createObjectURL(response.data)
    return {
      imgUrl,
      randomStr
    }
  } catch (e) {
    return {
      imgUrl: '',
      randomStr: ''
    }
  }
}

// 登录
export const login = (payload) => {
  payload.password = SHA256(payload.password).toString()
  return request(API_SSO + '/login', payload)
}

// 登出
export const logout = (payload) => {
  return request(API_SSO + '/oauth/logout', payload)
}

// ---------------------------------------------------------------- //
// V2.0.1.2
// 获取用户信息
export const getUinfo = (payload) => request(API_BASE + '/myInfo/getUInfo', payload)


// 第三方登录
export const thridJump = (payload) => requestByThirdPath(API_SSO + '/oauth/platform/login?' + payload)
export const getThridJumpUrl = (payload) => {
  const basePath = process.env.VUE_APP_BASEPATH || ''
  return `${basePath}${API_SSO}/oauth/platform/login?${payload}`
}
